import { useSkeletonContext } from '../context/LoadingSkeletonContext';
import type { SkeletonShapeProps } from '../types';

import { RectangleStyles } from './Rectangle.styles';

export function Rectangle(props: SkeletonShapeProps) {
	const { className = '', loading: loadingProp, rounded = false } = props;

	const { loading, shapeColorClassName } = useSkeletonContext();

	const resolvedLoading = loadingProp ?? (loading || false);
	const mergedClassName = `${shapeColorClassName} ${className}`.trim();

	const styles = RectangleStyles({ loading: resolvedLoading, rounded, class: mergedClassName });

	return <div className={styles} />;
}
